import React, { Component } from 'react'

export default class ErrorPopUp extends Component {
    render() {
        return (
            <div className='user_popup active'>
            <span className="popup_overlay" onClick={this.props.errorMsgPopup}></span>
            <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
                <div className="approve_popup_header text_center relative">
                    <p>{this.props.errorMsg}</p>
                </div>
                <div className="content">
                    <div className="field_row text_center">
                        <button className="small_btn active" onClick={this.props.errorMsgPopup}>OK</button>
                    </div>
                </div>
            </div>
        </div>
        )
    }
}